import { treeViewAnatomy } from "@chakra-ui/react/anatomy";
import { defineSlotRecipe } from "@chakra-ui/react/styled-system";

export default defineSlotRecipe({
  slots: treeViewAnatomy.keys(),
  base: {
    // A branch row can carry its own control beside the row (the Inbox
    // tree's "Your access" button). It is a sibling of the branch control,
    // never inside it: a control within a role="button" element is not
    // allowed. The grid keeps it on the row; the children span below.
    branch: {
      display: "grid",
      gridTemplateColumns: "minmax(0, 1fr) auto",
      alignItems: "center",
    },
    branchControl: {
      gridColumn: "1",
    },
    branchContent: {
      gridColumn: "1 / -1",
    },
  },
});
